// extracted by mini-css-extract-plugin
export var container = "_71-0";
export var error = "_71-9";
export var label = "_71-5";
export var light = "_71-6";
export var md = "_71-3";
export var sm = "_71-2";
export var thin = "_71-8";
export var thinBold = "_71-7";
export var vertical = "_71-4";
export var xs = "_71-1";